import React from 'react';
import {WEB_SCREENS} from '../../constants/screens';
import {storyAssets} from '../../constants/assets';
import {TrackingEvents} from '../../../../Utilities/analytics';
import {storyDataArrayProps} from '../../types';
import {WebStoryNavigation} from '../../navigation/types';
import {playTapSound} from '../../utils/storyHelpers';
import WebObjectView from '../WebObjectView';
import {WebLottieSource} from '../WebLottiePlayer';
import '../../styles/objectLayout.css';

interface ObjectViewListProps {
  enablebagPack: boolean;
  enableJournal: boolean;
  enableFunbox: boolean;
  enableMywall: boolean;
  ballonObject: boolean;
  navigation: WebStoryNavigation;
  routeParams: {storyId?: string};
  storyDataArray: storyDataArrayProps;
  setSelectedobject: (_value: WebLottieSource) => void;
  setShowObjectView: (_value: boolean) => void;
  setDisplayName: (_value: string) => void;
  setIsNavigateToJourney: (_value: boolean) => void;
  setYetiIntroArr: () => void;
  handleBlockSubmit: () => void;
  currentObjectScreen: string;
  onNavigateToPlanner?: () => void;
  onTrackEvent?: (event: string, props?: Record<string, unknown>) => void;
}

const ObjectViewList: React.FC<ObjectViewListProps> = ({
  enablebagPack,
  enableJournal,
  enableFunbox,
  enableMywall,
  ballonObject,
  navigation,
  routeParams,
  storyDataArray,
  setSelectedobject,
  setShowObjectView,
  setIsNavigateToJourney,
  setYetiIntroArr,
  handleBlockSubmit,
  currentObjectScreen,
  setDisplayName,
  onNavigateToPlanner,
  onTrackEvent,
}) => {
  const handleObjectClick = (objectSource: WebLottieSource, objectName: string) => {
    onTrackEvent?.(TrackingEvents.object_clicked, {
      object_name: objectName.toLowerCase(),
      from: 'story',
    });

    setSelectedobject(objectSource);

    if (objectName.toLowerCase() !== 'my journey') {
      setShowObjectView(true);
    }
    if (objectName?.toLowerCase() === 'planner') {
      onNavigateToPlanner?.();
    }

    handleBlockSubmit();
    setYetiIntroArr();

    setTimeout(() => {
      const isLastBlock = storyDataArray?.data?.blocks?.length === 1;

      switch (objectName.toLowerCase()) {
        case 'planner':
          break;
        case 'funbox':
          navigation.navigate(WEB_SCREENS.ApplicationNavigatorStack, {
            screen: WEB_SCREENS.FunBoxScreen,
            params: {
              navigatedFrom: 'story',
              storyId: routeParams?.storyId,
              isLastBlock,
            },
          });
          break;
        case 'my wall':
          navigation.navigate(WEB_SCREENS.ApplicationNavigatorStack, {
            screen: WEB_SCREENS.MyWall,
            params: {
              navigatedFrom: 'story',
              storyId: routeParams?.storyId,
              isLastBlock,
            },
          });
          break;
        case 'magic backpack':
          navigation.navigate(WEB_SCREENS.ApplicationNavigatorStack, {
            screen: WEB_SCREENS.MagicBagPack,
            params: {
              navigatedFrom: 'story',
              storyId: routeParams?.storyId,
              isLastBlock,
            },
          });
          break;
        case 'my journey':
          setIsNavigateToJourney(true);
          break;
        default:
          break;
      }

      setSelectedobject('');
      setShowObjectView(false);
    }, 2000);
  };

  return (
    <>
      {enablebagPack && (
        <WebObjectView
          sourceImg={storyAssets.lottie.bouncyBag}
          containerClassName="web-obj-bag"
          onObjectPress={() => {
            setDisplayName('Magic Backpack');
            playTapSound(storyAssets.objectTapSound);
            handleObjectClick(storyAssets.lottie.bouncyBag, 'Magic Backpack');
          }}
          animateObject={currentObjectScreen === WEB_SCREENS.MagicBagPack}
        />
      )}
      {enableJournal && (
        <WebObjectView
          sourceImg={storyAssets.lottie.plannerIcon}
          containerClassName="web-obj-planner"
          onObjectPress={() => {
            setDisplayName(' Planner');
            playTapSound(storyAssets.objectTapSound);
            handleObjectClick(storyAssets.lottie.plannerIcon, 'planner');
          }}
          animateObject={currentObjectScreen === WEB_SCREENS.KidsJournal}
        />
      )}
      {enableFunbox && (
        <WebObjectView
          sourceImg={storyAssets.lottie.bouncyBox}
          containerClassName="web-obj-funbox"
          onObjectPress={() => {
            setDisplayName(' Fun Box');
            playTapSound(storyAssets.objectTapSound);
            handleObjectClick(storyAssets.lottie.bouncyBox, 'FunBox');
          }}
          animateObject={currentObjectScreen === WEB_SCREENS.FunBoxScreen}
        />
      )}
      {enableMywall && (
        <WebObjectView
          sourceImg={storyAssets.lottie.bouncyFrame}
          containerClassName="web-obj-wall"
          onObjectPress={() => {
            setDisplayName(' My Wall');
            playTapSound(storyAssets.objectTapSound);
            handleObjectClick(storyAssets.lottie.bouncyFrame, 'My Wall');
          }}
          animateObject={currentObjectScreen === WEB_SCREENS.MyWall}
        />
      )}
      {ballonObject && (
        <WebObjectView
          sourceImg={storyAssets.lottie.floatingBallon}
          containerClassName="web-obj-balloon"
          onObjectPress={() => {
            playTapSound(storyAssets.objectTapSound);
            handleObjectClick(storyAssets.lottie.floatingBallon, 'My Journey');
          }}
          animateObject={currentObjectScreen === WEB_SCREENS.MyJourneyScreen}
        />
      )}
    </>
  );
};

export default ObjectViewList;
